<template>
  <div class="partners-carousel">
    <h2 class="partners-carousel__title">{{ $tAbout('Our partners') }}</h2>
    <div class="partners-carousel__outer">
      <div ref="carousel" class="partners-carousel__wrap">
        <div class="partners-carousel__list">
          <div class="partners-carousel__item"
               v-for="item in data"
               :key="item.id"
          >
            <v-lazy-image :src="item.image"
                          :title="createTitleMixin(item.name)"
                          :alt="createAltMixin(`${item.name} - ${$tAbout('Наші партнери')}`)"
                          use-picture>
              <source v-if="item.image_webp"
                      :srcset="item.image_webp"
                      type="image/webp">
            </v-lazy-image>
          </div>
        </div>
      </div>
      <button ref="prev" class="partners-carousel__carousel-nav  _prev  base-btn  base-btn--outline-dark  d-sm-none" >
        <BaseSvg name="ico-arrow-light-2"/>
      </button>
      <button ref="next" class="partners-carousel__carousel-nav  _next  base-btn  base-btn--outline-dark d-sm-none">
        <BaseSvg name="ico-arrow-light-2"/>
      </button>
      <div ref="pagination" class="partners-carousel__pagination d-none d-sm-flex"></div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'

  export default {
    name: 'PartnersCarousel',
    props: {
      data: Array
    },
    data() {
      return {
        swiper: null
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'partners-carousel__list',
          slideClass: 'partners-carousel__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          centerInsufficientSlides: true,

          navigation: {
            prevEl: this.$refs.prev,
            nextEl: this.$refs.next,
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },

          pagination: {
            el: this.$refs.pagination,
            type: 'bullets',
            bulletClass: 'partners-carousel__pagination-item',
            bulletActiveClass: '_active',
            lockClass: '_hidden',
            clickable: true
          },
        })
      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy()
      }
    },
  }
</script>

<style>

</style>
